import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/** Card section for detail pages: heading row with optional actions, then body. */
@Component({
  selector: 'app-detail-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <section class="pp-panel" [class.pp-panel--compact]="compact">
      <div *ngIf="heading" class="pp-panel__head">
        <h3>
          <i *ngIf="icon" class="pi" [ngClass]="icon"></i>
          {{ heading }}
          <span *ngIf="count !== null && count !== undefined" class="pp-panel__count">{{ count }}</span>
        </h3>
        <div class="pp-panel__actions">
          <ng-content select="[panelActions]"></ng-content>
        </div>
      </div>
      <div *ngIf="loading" class="pp-skel-lines">
        <span class="pp-skel pp-skel--w60"></span>
        <span class="pp-skel pp-skel--w85"></span>
        <span class="pp-skel pp-skel--w40"></span>
      </div>
      <div class="pp-panel__body" [hidden]="loading">
        <ng-content></ng-content>
      </div>
    </section>
  `,
  styles: [':host { display: block; min-width: 0; }'],
})
export class DetailPanelComponent {
  @Input() heading = '';
  /** PrimeIcons name without the `pi ` prefix, e.g. `pi-user`. */
  @Input() icon = '';
  @Input() count: number | string | null | undefined = null;
  @Input() loading = false;
  @Input() compact = false;
}
